import { useEffect, useRef, useState } from "react";

const SWIPE_THRESHOLD_PX = 50;
const CLICK_SUPPRESS_THRESHOLD_PX = 5;

/**
 * Permite cambiar de slide arrastrando con el ratón en un Carousel de react-bootstrap,
 * que de serie solo soporta el gesto táctil. Devuelve las props para el Carousel (modo
 * controlado) y los handlers para el contenedor.
 */
const useMouseDragCarousel = (itemCount) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const dragStateRef = useRef({
    isMouseDown: false,
    moved: false,
    startX: 0,
    startY: 0,
  });

  useEffect(() => {
    if (activeIndex >= itemCount) {
      setActiveIndex(0);
    }
  }, [itemCount]);

  useEffect(() => {
    const handleMouseMove = (event) => {
      const state = dragStateRef.current;
      if (!state.isMouseDown) {
        return;
      }

      const deltaX = Math.abs(event.clientX - state.startX);
      const deltaY = Math.abs(event.clientY - state.startY);

      if (Math.max(deltaX, deltaY) > CLICK_SUPPRESS_THRESHOLD_PX) {
        state.moved = true;
      }
    };

    const handleMouseUp = (event) => {
      const state = dragStateRef.current;
      if (!state.isMouseDown) {
        return;
      }
      state.isMouseDown = false;

      const deltaX = event.clientX - state.startX;
      const deltaY = event.clientY - state.startY;

      if (itemCount > 1 && Math.abs(deltaX) > SWIPE_THRESHOLD_PX && Math.abs(deltaX) > Math.abs(deltaY)) {
        const direction = deltaX < 0 ? 1 : -1;
        setActiveIndex((current) => (current + direction + itemCount) % itemCount);
      }

      requestAnimationFrame(() => {
        state.moved = false;
      });
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [itemCount]);

  const onMouseDown = (event) => {
    if (event.button !== 0) {
      return;
    }

    // Evita la selección de texto y el arrastre nativo de imágenes mientras se desliza
    event.preventDefault();

    const state = dragStateRef.current;
    state.isMouseDown = true;
    state.moved = false;
    state.startX = event.clientX;
    state.startY = event.clientY;
  };

  const onClickCapture = (event) => {
    if (!dragStateRef.current.moved) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    dragStateRef.current.moved = false;
  };

  const onDragStartCapture = (event) => {
    event.preventDefault();
  };

  return {
    carouselProps: {
      activeIndex,
      onSelect: (selectedIndex) => setActiveIndex(selectedIndex),
    },
    dragHandlers: {
      onMouseDown,
      onClickCapture,
      onDragStartCapture,
    },
  };
};

export default useMouseDragCarousel;
